/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        container: {
            minWidth: 'xs',
            width: 'full',
            boxShadow: 'base',
            // backgroundColor: 'rgba(0, 0, 0, 0.60)',
            backgroundColor: 'black',
            color: 'white'
        },
        content: {
            maxWidth: 'container.xxl',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: [4, 4, 6, 8, 8, 0],
            paddingRight: [4, 4, 6, 8, 8, 0],
            paddingTop: 0,
            paddingBottom: 0
        },
        bodyContainer: {
            flex: '1',
            padding: 0,
            paddingRight: {xl: 8},
            paddingLeft: {xl: '17rem'}
        },
        localeSelector: {
            display: ['none', 'none', 'none', 'block'],
            position: 'relative'
        },
        logo: {
            width: ['8.125rem', null, null, null, '12.82281rem'],
            height: ['1.4375rem', null, null, null, '2.89006rem'],
            position: {xl: 'relative'},
            top: {xl: props.isShrunk ? '0' : '1.75rem'}, // 28px
            transition: 'top ease-in-out 0.3s'
        },
        logoContainer: {
            backgroundColor: 'yellow.400',
            padding: '0 1rem',
            borderRadius: 0,
            transition: 'height ease-in-out 0.3s',
            height: {base: '3.125rem', xl: props.isShrunk ? '3.75rem' : '9.375rem'},
            position: {xl: 'absolute'},
            zIndex: 11,
            top: {xl: 0}
        },
        icons: {
            marginBottom: 0
        },
        accountIcon: {marginLeft: 3, minWidth: 'auto'},
        cartIcon: {marginLeft: 3, fontSize: 'md'},
        arrowDown: {
            height: 11,
            minWidth: 'auto',
            marginRight: 0,
            alignSelf: ['self-start', 'self-start', 'self-start', 'auto'],
            cursor: 'pointer',
            _focus: {
                boxShadow: 'outline'
            },
            _focusVisible: {
                outline: 0
            },
            display: ['none', 'none', 'none', 'none', 'block']
        },
        signout: {
            width: '100%',
            borderRadius: '4px',
            height: 11,
            padding: 4,
            py: 3,
            marginTop: 1,
            _hover: {
                background: 'gray.50'
            }
        },
        signoutText: (props) => ({
            ...props.theme.textStyle.mediumLarge,
            color: 'black'
        }),
        signoutIcon: {
            marginRight: 2
        }
    }),
    sizes: {},
    parts: ['container', 'content', 'bodyContainer', 'logo', 'icons', 'signout', 'logoContainer']
}
